import CustomStore from "devextreme/data/custom_store";
import { apiConfiguration } from "../apiConfig";
import { FiliereApi, PermissionsApi } from "../data/apis";

export const filiereDataSource = new CustomStore({
    key: "filieraPermissionId",
    loadMode : 'raw',
    load: (loadOptions) => {
      const api = new FiliereApi(apiConfiguration);
        return api.getFiliere();
    },
  
    // byKey: (key) => {
    //   const permissionsApi = new PermissionsApi(apiConfiguration);
    //     return permissionsApi.getTipoMangimeById({id:key});
    // },
  
    // insert: (values) => {
    //   const permissionsApi = new PermissionsApi(apiConfiguration);
    //   return permissionsApi.insertTipoMangime({
    //     tipoMangimeCreateDTO: values
    //   });
    // },
  
    // update: (key, values) => {
    //   const permissionsApi = new PermissionsApi(apiConfiguration);
    //   return permissionsApi.updateTipoMangime({
    //     id: key,
    //     tipoMangimeUpdateDTO: values
    //   });
    // },
  
    //  remove: (key) => {
    //   const permissionsApi = new PermissionsApi(apiConfiguration);
    //   return permissionsApi.deleteTipoMangime({
    //     id: key
    //   });
    //  }
    update: (key, values) => { return Promise.resolve();}
  });